import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';

@Component({
  selector: 'assessment-info',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './assessment-info.component.html',
  styleUrl: './assessment-info.component.css'
})
export class AssessmentInfoComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  @ViewChild('datepickerStartDate') datepickerStartDate!: ElementRef;
  
  assessInfoForm: FormGroup = new FormGroup([]);
  question = {
    question: 'Sources of information used in this threat assessment:',
    formControlName: 'source_of_information',
    answers: [
      'Student information from the SIS', 'Academic history', 'Attendance records',
      'Student behavior records', 'IEP/504 plans', 'Schoolwork',
      'Behavior or Management Plans', 'Personal belongings', 'Social networking sites',
      'Emails/text messages', 'Internet histories', 'Interviews',
      'Law enforcement records', 'Mental health records', 'Probation records', 'Other'
    ]
  };

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.assessInfoForm = new FormGroup({
      date_started: new FormControl(this.fullTeamAssessmentData?.date_started || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required),
      time_started: new FormControl(this.fullTeamAssessmentData?.time_started || '11:00', Validators.required),
      source_of_information: new FormControl(this.fullTeamAssessmentData?.source_of_information || '', Validators.required)
    });
  }

  onCheckboxChange(e: any, controlName: string, value: string) {
    const currentValues = new Set(this.assessInfoForm.get(controlName)!.value.split(', ').filter((v: string) => v));
    if (e.target.checked) {
      currentValues.add(value);
    } else {
      currentValues.delete(value);
    }
    this.assessInfoForm.get(controlName)?.setValue(Array.from(currentValues).join(', '));
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerStartDate) {
        new Datepicker(this.datepickerStartDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.fullTeamAssessmentData?.date_started) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerStartDate.nativeElement.value = DateUtils.formatDateForDisplay(this.fullTeamAssessmentData.date_started);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerStartDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerStartDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.assessInfoForm.get('date_started')?.setValue(formattedDate);
        });
      }
    }
  }

  saveAssessInfo(): void {
    if (this.assessInfoForm.valid) {
        this.onSaveSection1.emit(this.assessInfoForm.value);
    }
  }


}
